export const features = {
  donate: false
};
